import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';

import { selectOption } from 'src/redux/view/actions';
import { SELECT_OPTION_STATE_KEY } from 'src/redux/view/constants';

export class SelectBoxContainer extends Component {
  onChange = event => {
    this.handleSelection(event.target.value);
  };

  handleSelection = selectedOptionIndex => {
    this.props.dispatchSelect(
      this.props.id,
      this.props.options[Number(selectedOptionIndex)].value,
    );
  };

  buildSelectOptionProps = () => {
    const presentationData = [];
    for (let i = 0, len = this.props.options.length; i < len; i++) {
      const data = this.props.options[i];
      presentationData.push({
        optionIndex: i,
        title: data.title,
        value: data.value,
        disabled: data.disabled || undefined,
      });
    }
    return presentationData;
  };
  getCurrentOptionIndex = () => {
    for (let i = 0, len = this.props.options.length; i < len; i++) {
      if (this.props.options[i].value === this.props.value) return i;
    }
    // If not found a proper value set the first value
    if (this.props.options.length > 0) {
      this.handleSelection('0');
    }
  };

  render() {
    return (
      <SelectBoxPresentation
        id={this.props.id}
        data={this.buildSelectOptionProps()}
        selectedOptionIndex={this.getCurrentOptionIndex()}
        onChange={this.onChange}
      />
    );
  }
}

export class SelectBoxPresentation extends Component {
  mapDataToSelectOptions = (item, _index) => {
    const label =
      item.title.slice(0, 50) + (item.title.length > 50 ? '...' : '');
    return {
      value: item.optionIndex,
      label: label,
      isDisabled: item.disabled || false,
    };
  };

  handleSelectChange = selectedOption => {
    if (selectedOption && this.props.onChange) {
      // Create a synthetic event to match the expected interface
      const syntheticEvent = {
        target: {
          value: selectedOption.value,
        },
      };
      this.props.onChange(syntheticEvent);
    }
  };

  render() {
    const options = this.props.data.map(this.mapDataToSelectOptions);
    const selectedOption = options.find(
      option => option.value === this.props.selectedOptionIndex,
    );

    return (
      <div className="form-group">
        <Select
          id={this.props.id}
          options={options}
          value={selectedOption}
          onChange={this.handleSelectChange}
          className="col-md-2"
          classNamePrefix="react-select"
        />
      </div>
    );
  }
}

export const mapStateToProps = (state, ownProps) => {
  let selectBoxState;
  try {
    selectBoxState =
      state.viewState[SELECT_OPTION_STATE_KEY][ownProps.id] || {};
  } catch {
    selectBoxState = {};
  }
  const newState = {
    isFetching: false,
    error: null,
    value: null,
    ...selectBoxState,
  };
  return newState;
};

export const mapDispatchToProps = dispatch => {
  return {
    dispatchSelect: (selectBoxID, value) => {
      dispatch(selectOption(selectBoxID, value));
    },
  };
};

export const SelectBox = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectBoxContainer);
